const Support = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="a">
          <rect
            width="18"
            height="18"
            transform="translate(0.189)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(636 -4384)">
        <g transform="translate(-636.189 4384)">
          <g transform="translate(1.078)">
            <g transform="translate(0)">
              <path
                d="M38.91,0A7.919,7.919,0,0,0,31,7.91V12.2a1.584,1.584,0,0,0,1.582,1.582H33.2a1.582,1.582,0,0,0,3.073-.527V8.965A1.582,1.582,0,0,0,33.2,8.438h-.618a1.574,1.574,0,0,0-.527.091V7.91a6.855,6.855,0,0,1,13.711,0v.618a1.575,1.575,0,0,0-.527-.091H44.62a1.582,1.582,0,0,0-3.073.527v4.289a1.582,1.582,0,0,0,2.041,1.514,1.585,1.585,0,0,1-1.514,1.123H40.4a1.582,1.582,0,1,0,0,1.055h1.673a2.64,2.64,0,0,0,2.637-2.637v-.527h.527A1.584,1.584,0,0,0,46.82,12.2V7.91A7.919,7.919,0,0,0,38.91,0ZM34.164,8.965a.527.527,0,0,1,1.055,0v4.289a.527.527,0,0,1-1.055,0Zm-1.582.527h.527v3.234h-.527a.528.528,0,0,1-.527-.527V10.02A.528.528,0,0,1,32.582,9.492Zm6.328,7.453a.527.527,0,1,1,.527-.527A.528.528,0,0,1,38.91,16.945Zm4.746-3.691a.527.527,0,0,1-1.055,0V8.965a.527.527,0,0,1,1.055,0ZM45.766,12.2a.528.528,0,0,1-.527.527h-.527V9.492h.527a.528.528,0,0,1,.527.527Z"
                transform="translate(-31)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Support;
